import { Injectable } from "@angular/core";
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { WorkOrderStatus } from 'projects/Autofacets-Core/src/app/utils/enums';
import { AppointmentRequestModel } from '../business-entities/appointmentList-model';
import { AppointmentStatusList } from "../business-entities/appointmentStatus-model";
import { AppointmentJobPackageModel, WorkOrderDetailsViewModel, WorkOrderHistoryViewModel } from "../business-entities/work-order-details-view-model";
import { AppointmentDataService } from "../data-services/appointment-data.service";
import { DealerServiceFilterModel } from "../../../../Widget/src/app/business-entities/dealer-service-filter-model";
import { UploadDocumentRequestModel } from "projects/Autofacets-Core/src/app/business-entities/upload-document-request-model";
@Injectable({
  providedIn: 'root'
})

export class AppointmentService {
  mobilenumber: string;
  licenseplatnumber: string;
  pdfTypeIndex: number;
  appointmentId: number;
  bookingDate: any = null;
  createdDate: any = null;
  AppointmentDay: any = null;
  filterTypeId: number = 0;
  dateFlag: number = 0;
  appointmentList : any;
  appointmentRequestModel: AppointmentRequestModel =
    {
      appointmentStatusId: null,
      workOrderStatusId: null,
      bookingDate: null,
      createdDate: null,
      dealerId: null,
      serviceAdvisorId:null,
      isAuthorizedByServiceAdvisor:false,
      mechanicId:null,
      brandCode : null,
      searchTerm: null,
      startRecordNumber: 0,
      pageSize: 0,
      sortColumn: "",
      sortDirection: "",
      appointmentType:"",
      documentPartStatus: null,
      sourceOfCreation: '',
      isFilterUnRepliedMessages: false,
      isWarrantyAppointment: 0,
      isWarrantyDocumentSigned: null,
      customerName: null,
      mobileNumber: null,
      woNumber: null,
      licensePlate: null,
      isCampaignService: null,
      isTireHotel: null
    };
  isShow: boolean = true;
  appointmentStatusList: AppointmentStatusList[] = [];
  isRefreshListing: boolean = true;
  billToCustomerNo:string = null;
  documentTypeId: number = 0;
  constructor(private readonly service: AppointmentDataService) {
  }
  GetDealerRentalCars(dealerId: any): Promise<GenericResponse<any>> {
    return this.service.GetDealerRentalCars(dealerId);
  }
  GetGenericRentalCars(languageId: string): Promise<GenericResponse<any>> {
    return this.service.GetGenericRentalCars(languageId);
  }
  GetAdditionalWorkDetails(id: number): Promise<any> {
    return this.service.GetAdditionalWorkDetails(id);
  }
  GetAppointmentList(appointmentRequestModel: AppointmentRequestModel): Promise<any> {
    return this.service.GetAppointmentList(appointmentRequestModel);
  }
  async GetAppointmentStatusList(languageCode: string): Promise<any> {
    return this.service.GetAppointmentStatusList(languageCode);
  }
  GetNextAvailableStatus(statusId: number, language: string,appointmentId:number): Promise<any> {
    return this.service.GetNextAvailableStatus(statusId, language,appointmentId);
  }
  UpdateAppointmentStatus(model: any): Promise<any> {
    return this.service.UpdateAppointmentStatus(model);
  }

  UpdateOnHoldStatus(model: any): Promise<any> {
    return this.service.UpdateOnHoldStatus(model);
  }

  UpdateAppointmentStatusList(model: any): Promise<any> {
    return this.service.UpdateAppointmentStatusList(model);
  }
  GetAllDealerDetails(model: any): Promise<GenericResponse<any>> {
    return this.service.GetAllDealerDetails(model);
  }
  GetCustomerWaitingLimit(model: any): Promise<GenericResponse<any>> {
    return this.service.GetCustomerWaitingLimit(model);
  }
  GetAdditionalServices(dealerId: string): Promise<GenericResponse<any>> {
    return this.service.GetAdditionalServices(dealerId);
  }

  GetSelectServiceSectionDetails(language: string): Promise<GenericResponse<any>> {
    return this.service.GetSelectServiceSectionDetails(language);
  }

  GetServiceDetail(Id: number, AppointmentGuid, languageCode = ""): Promise<any> {
    return this.service.GetServiceDetail(Id, AppointmentGuid,languageCode);
  }

  GetServicDetailForInvoice(appointmentGUID: string, pdfType: number): Promise<any> {
    return this.service.GetServicDetailForInvoice(appointmentGUID, pdfType);
  }

  GetAdditionalServiceDetail(Id: number): Promise<any> {
    return this.service.GetAdditionalServiceDetail(Id);
  }

  async SearchLicensePLate(LicensePLate: string,VINNo:string,EngineNo:string): Promise<any> {
    return this.service.SearchLicensePLate(LicensePLate,VINNo,EngineNo)
  }

  GetAppointmentService(id: number): Promise<any> {
    return this.service.GetAppointmentService(id);
  }
  GetServicesByDealerId(dealerServiceFilterModel:DealerServiceFilterModel): Promise<any> {
    return this.service.GetServicesByDealerId(dealerServiceFilterModel);
  }
  GetAllStatus(model: any): Promise<any> {
    return this.service.GetAllStatus(model);
  }

  GetOnHoldStatusReasonList(language: string,reasonTypeId: number): Promise<any> {
    return this.service.GetOnHoldStatusReasonList(language,reasonTypeId);
  }
  GetPdfType(): Promise<any> {
    return this.service.GetPdfType();
  }
  GetAllWorkOrderStatus(model: any): Promise<any> {
    return this.service.GetAllWorkOrderStatus(model);
  }
  GetAppointmentDetail(id: number, languageCode: string): Promise<any> {
    return this.service.GetAppointmentDetail(id, languageCode);
  }

  AddAppointment(viewmodel: any): Promise<any> {
    return this.service.AddAppointment(viewmodel);
  }
  AddCrmAppointment(viewmodel: any): Promise<any> {
    return this.service.AddCrmAppointment(viewmodel);
  }
  UpdateAppointment(viewmodel: any): Promise<any> {
    return this.service.UpdateAppointment(viewmodel);
  }
  UpdateAdditionalAppointment(viewmodel: any): Promise<any> {
    return this.service.UpdateAdditionalAppointment(viewmodel);
  }
  GetClockinDemandDetails(viewmodel: any): Promise<any> {
    return this.service.GetClockinDemandDetails(viewmodel);
  }
  DeleteAppointment(deleteModel: any): Promise<any> {
    return this.service.DeleteAppointment(deleteModel);
  }
  UpdateNeedAttention(viewModel: any): Promise<any> {
    return this.service.UpdateNeedAttention(viewModel);
  }
  SearchDealerParts(dealerId: string, partSearchText: string, languageCode: string): Promise<any> {
    return this.service.SearchDealerParts(dealerId, partSearchText, languageCode);
  }

  getStatusBrand(dealerId: string, appointmentId: number, languageCode: string): Promise<any> {
    return this.service.getStatusBrand(dealerId, appointmentId, languageCode);
  }
  getActiveAppointment(vehicleId: number, customerId: number, languageCode: string): Promise<any> {
    return this.service.getActiveAppointment(vehicleId, customerId, languageCode);
  }

  getDemandDescription(appointmentId:number, isWARAppointment:boolean): Promise<any>{
    return this.service.getDemandDescription(appointmentId, isWARAppointment);
  }

  UpdateAdditionalWorkDetails(model: any): Promise<any> {
    return this.service.UpdateAdditionalWorkDetails(model);
  }

  ShiftAppointment(dealerId: string, appointmentId: number,remark): Promise<any>{
    return this.service.ShiftAppointment(dealerId,appointmentId,remark)
  }

  getCustomerWithMobile(appointmentId:any): Promise<any>{
    return this.service.getCustomerWithMobile(appointmentId);
  }

  getWorkorderStatus(statusId: string): string {

    switch (statusId) {
      case WorkOrderStatus.WaitingForCustomer:
        return 'Waiting for customer';
      case WorkOrderStatus.CarArrived:
        return'Car arrived';
      case WorkOrderStatus.MechanicStarted:
        return 'Mechanic started';
      case WorkOrderStatus.ChecklistRecorded:
        return 'Checklist recorded';
      case WorkOrderStatus.MechanicDone:
        return 'Mechanic done';
      case WorkOrderStatus.WorkDone:
        return 'Work done';
      case WorkOrderStatus.InvoiceReady:
        return 'Invoice ready';
      case WorkOrderStatus.Closed:
        return 'Closed';
      case WorkOrderStatus.Cancelled:
        return 'Cancelled';
      case WorkOrderStatus.Prepared:
        return 'Prepared';

      default:
        return '';
    }

  }

  GetActiveWorkOrder(model: any): Promise<GenericResponse<Array<WorkOrderDetailsViewModel>>> {
    return this.service.GetActiveWorkOrder(model);
  }

  GetWorkOrderHistoryForVehicle(model: any): Promise<GenericResponse<Array<WorkOrderHistoryViewModel>>> {
    return this.service.GetWorkOrderHistoryForVehicle(model);
  }

  GetServicesList(languageCode: string): Promise<any> {
    return this.service.GetServicesList(languageCode);
  }
  async ResyncAppointment(appointmentId: number, moduleId: number) {
    return this.service.ResyncAppointment(appointmentId, moduleId);
  }
  async GetAppointmentDayList() {
    return this.service.GetAppointmentDayList();
  }

  GetLockedAppointmentList(model) {
    return this.service.GetLockedAppointmentList(model);
  }
  UnlockAppointment(model) {
    return this.service.UnlockAppointment(model);
  }
  IsLockedByOtherUser(appointmentGuid) {
    return this.service.IsLockedByOtherUser(appointmentGuid);
  }

  GetUpdateAppointmentHistory(id: number): Promise<any> {
    return this.service.GetUpdateAppointmentHistory(id);
  }
  async AddAppointmentJobPackageInDms(jobInfo: AppointmentJobPackageModel): Promise<any> {
    return  this.service.AddAppointmentJobPackageInDms(jobInfo);
    }

    AddAppointmentAsQuoteFromRejectedDemand(viewmodel: any): Promise<any> {
        return this.service.AddAppointmentAsQuoteFromRejectedDemand(viewmodel);
    }

    AddAppointmentAsQuoteFromDemand(viewmodel: any): Promise<any> {
        return this.service.AddAppointmentAsQuoteFromDemand(viewmodel);
    }

    SplitDemandsFromExistingAppointment(viewmodel: any): Promise<any> {
        return this.service.SplitDemandsFromExistingAppointment(viewmodel);
    }

    GetDemandWiseDocuments(demandId:number) : Promise<any>{
      return this.service.GetDemandWiseDocuments(demandId);
    }
    GetFile(url:string): Promise<any>{
      return this.service.GetFile(url);
    }
    async UploadDocumentFromPlanner(docs:UploadDocumentRequestModel[]): Promise<any>{
      return this.service.UploadDocumentFromPlanner(docs);
    }
    GetDocumentCount(AppointmentId: number): Promise<any> {
      return this.service.GetDocumentCount(AppointmentId);
    }
    MoveRequestForJobDetails(model:any): Promise<any> {
      return this.service.MoveRequestForJobDetails(model);
    }
    RefreshCustomerData(AppointmentId: number, integrationWithDms:boolean): Promise<any> {
      return this.service.RefreshCustomerData(AppointmentId,integrationWithDms);
    }
    RefreshVehicleData(AppointmentId: number, integrationWithDms:boolean): Promise<any> {
      return this.service.RefreshVehicleData(AppointmentId,integrationWithDms);
    }

  getManualNotificationData(requestModel: any): Promise<any> {
    return this.service.getManualNotificationData(requestModel);
  }
  GetWorkOrderStatusDetails(model:any) {
    return this.service.GetWorkOrderStatusDetails(model);
  }
  
  getServiceCampaignOption(){
    return this.service.getServiceCampaignOption();
  }

  syncDemandToSST(appointmentGUID:any,appointmentId:any){
    return this.service.syncDemandToSST(appointmentGUID,appointmentId);
  }

  GetSyncFailAppointmentList(appointmentRequestModel: AppointmentRequestModel): Promise<GenericResponse<any>> {
    return this.service.GetSyncFailAppointmentList(appointmentRequestModel);
  }

  UpdateSyncFailAppointment(appointmentId: string): Promise<GenericResponse<any>> {
    return this.service.UpdateSyncFailAppointment(appointmentId);
  }

  ReOpenAppointment(workOrderNumber:string): Promise<any> {
    return this.service.ReOpenAppointment(workOrderNumber);
  }

  UpdateQuoteExpireDate(appointmentId: string): Promise<GenericResponse<any>> {
    return this.service.UpdateQuoteExpireDate(appointmentId);
  }

  updateSellToBillToCustomer(modal){
    return this.service.updateSellToBillToCustomer(modal);
  }
}
